// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0df89f2b","971":"368bb3fa"}[chunkId] + ".chunk.js";
};